/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  ConnectionCursor: { input: string; output: string };
  /** A date without time that follows the RFC3339Nano spec. Example: '2022-09-18' */
  Date: { input: string; output: string };
  /** A date with time that follows the RFC3339Nano spec. Example: '2022-09-18T23:12:23-06:00' */
  DateTime: { input: string; output: string };
  /** A valid domain name. Example: 'example.com' */
  Domain: { input: any; output: any };
  Email: { input: string; output: string };
  /** A percentage represented as an integer. Example: 5 represents 5% */
  Percentage: { input: number; output: number };
  /** A valid URL with a scheme of http, https */
  URL: { input: any; output: any };
};

export type AmazonBusinessAccount = {
  __typename?: 'AmazonBusinessAccount';
  amazonAccountEmail: Scalars['String']['output'];
  buyerEmail: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  oauthStatus: AmazonBusinessOauthStatus;
};

export type AmazonBusinessAccountInput = {
  amazonAccountEmail?: InputMaybe<Scalars['String']['input']>;
  buyerEmail?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  payer?: InputMaybe<BillingItemParty>;
};

export enum AmazonBusinessAccountOwner {
  Developer = 'DEVELOPER',
  Rye = 'RYE',
}

export type AmazonBusinessAuthStatusResponse = {
  __typename?: 'AmazonBusinessAuthStatusResponse';
  status: AmazonBusinessOauthStatus;
};

/** Deprecated: Type for the Amazon Business config */
export type AmazonBusinessConfig = {
  __typename?: 'AmazonBusinessConfig';
  email: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  oauthStatus: AmazonBusinessOauthStatus;
  owner: AmazonBusinessAccountOwner;
  parentAccountEmail: Scalars['String']['output'];
};

/** Deprecated: Input for updating the Amazon Business config */
export type AmazonBusinessConfigInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  parentAccountEmail?: InputMaybe<Scalars['String']['input']>;
  payer?: InputMaybe<BillingItemParty>;
};

export enum AmazonBusinessOauthStatus {
  Active = 'ACTIVE',
  Revoked = 'REVOKED',
}

export type AmazonProduct = Product & {
  __typename?: 'AmazonProduct';
  currency: Currency;
  id: Scalars['ID']['output'];
  images: Array<Image>;
  isAvailable: Scalars['Boolean']['output'];
  price: Scalars['Int']['output'];
  store: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['URL']['output'];
};

export type Amount = {
  __typename?: 'Amount';
  currency: Currency;
  value: Scalars['Float']['output'];
};

export type AmountInput = {
  currency: Currency;
  value: Scalars['Float']['input'];
};

export enum ApiType {
  SellAnything = 'SELL_ANYTHING',
  SyncApi = 'SYNC_API',
}

export type AttachPaymentMethodInput = {
  billingDetails: BillingDetailsInput;
  /** Payment method id */
  id: Scalars['ID']['input'];
};

export type AttachPaymentMethodResponse = {
  __typename?: 'AttachPaymentMethodResponse';
  /**
   * Present when the added US bank account must be verified with microdeposits before it can be charged.
   * stripeConfig stays the payment method already saved for the customer. The new bank is not the default while this is set.
   */
  pendingMicrodepositVerification?: Maybe<PendingMicrodepositVerification>;
  stripeConfig: StripeConfig;
};

export enum AuthProvider {
  Firebase = 'FIREBASE',
  Google = 'GOOGLE',
  Local = 'LOCAL',
}

export type AuthorizeAmazonBusinessInput = {
  code: Scalars['String']['input'];
};

export type AuthorizeAmazonBusinessResponse = {
  __typename?: 'AuthorizeAmazonBusinessResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type BillingDetailsInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type BillingFiltersInput = {
  amount?: InputMaybe<AmountInput>;
  endDate: Scalars['DateTime']['input'];
  orderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  payers?: InputMaybe<Array<BillingItemParty>>;
  receivers?: InputMaybe<Array<BillingItemParty>>;
  startDate: Scalars['DateTime']['input'];
  types?: InputMaybe<Array<BillingItemType>>;
};

export type BillingItem = {
  __typename?: 'BillingItem';
  amount: Amount;
  billingSetting: BillingSetting;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  orderId: Scalars['ID']['output'];
  payer: BillingItemParty;
  receiver: BillingItemParty;
  type: BillingItemType;
};

export type BillingItemEdge = {
  __typename?: 'BillingItemEdge';
  cursor: Scalars['ConnectionCursor']['output'];
  node: BillingItem;
};

export enum BillingItemParty {
  Affiliate = 'AFFILIATE',
  Developer = 'DEVELOPER',
  DeveloperDrawdown = 'DEVELOPER_DRAWDOWN',
  Merchant = 'MERCHANT',
  PayerUnknown = 'PAYER_UNKNOWN',
  Rye = 'RYE',
  Shopper = 'SHOPPER',
  Unrecognized = 'UNRECOGNIZED',
}

export type BillingItemResponse = {
  __typename?: 'BillingItemResponse';
  edges: Array<BillingItemEdge>;
  pageInfo: BillingPageInfo;
};

export enum BillingItemType {
  AffiliateCommission = 'AFFILIATE_COMMISSION',
  AffiliateCommissionDeveloperShare = 'AFFILIATE_COMMISSION_DEVELOPER_SHARE',
  AffiliateCommissionRyeShare = 'AFFILIATE_COMMISSION_RYE_SHARE',
  Credit = 'CREDIT',
  DeveloperFulfilled = 'DEVELOPER_FULFILLED',
  DiscountCommission = 'DISCOUNT_COMMISSION',
  DiscountCommissionDeveloperShare = 'DISCOUNT_COMMISSION_DEVELOPER_SHARE',
  DiscountCommissionRyeShare = 'DISCOUNT_COMMISSION_RYE_SHARE',
  FulfillmentFee = 'FULFILLMENT_FEE',
  MarkupCommission = 'MARKUP_COMMISSION',
  MarkupCommissionDeveloperShare = 'MARKUP_COMMISSION_DEVELOPER_SHARE',
  MarkupCommissionRyeShare = 'MARKUP_COMMISSION_RYE_SHARE',
  MerchantCommission = 'MERCHANT_COMMISSION',
  MerchantCommissionDeveloperShare = 'MERCHANT_COMMISSION_DEVELOPER_SHARE',
  MerchantCommissionRyeShare = 'MERCHANT_COMMISSION_RYE_SHARE',
  Order = 'ORDER',
  PlatformFee = 'PLATFORM_FEE',
  PlatformFeeRefund = 'PLATFORM_FEE_REFUND',
  Refund = 'REFUND',
  RyeServiceFee = 'RYE_SERVICE_FEE',
}

export type BillingItemsPaginationInput = {
  after?: InputMaybe<Scalars['ConnectionCursor']['input']>;
  before?: InputMaybe<Scalars['ConnectionCursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type BillingMonthly = BillingPeriodSettings & {
  __typename?: 'BillingMonthly';
  endDate: Scalars['DateTime']['output'];
  gracePeriodDays: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type BillingNotifications = {
  __typename?: 'BillingNotifications';
  emails?: Maybe<Array<Scalars['String']['output']>>;
};

export type BillingPageInfo = {
  __typename?: 'BillingPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  startCursor?: Maybe<Scalars['String']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type BillingPeriodSettings = {
  gracePeriodDays: Scalars['Int']['output'];
};

export type BillingPrePayment = BillingPeriodSettings & {
  __typename?: 'BillingPrePayment';
  currency: Currency;
  endDate: Scalars['DateTime']['output'];
  gracePeriodDays: Scalars['Int']['output'];
  lastRefillDate: Scalars['DateTime']['output'];
  minBalance: Scalars['Int']['output'];
  remainingBalance: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type BillingSetting = {
  __typename?: 'BillingSetting';
  developerCommissionShare: Scalars['Int']['output'];
  gmvTier: GmvTier;
  merchantCommissionRate: Scalars['Float']['output'];
  volumeTiers: Array<VolumeTier>;
};

export enum BillingStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Inactive = 'INACTIVE',
  Paused = 'PAUSED',
  Trial = 'TRIAL',
}

export type BillingSubscription = BillingPeriodSettings & {
  __typename?: 'BillingSubscription';
  endDate: Scalars['DateTime']['output'];
  gracePeriodDays: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  status: BillingStatus;
};

export type BillingTransfer = {
  __typename?: 'BillingTransfer';
  amount: Amount;
  note: Scalars['String']['output'];
  payer: BillingItemParty;
  receiver: BillingItemParty;
  timestamp: Scalars['DateTime']['output'];
  type: BillingTransferType;
};

export enum BillingTransferType {
  Cancelled = 'CANCELLED',
  Commission = 'COMMISSION',
  Payment = 'PAYMENT',
  Refund = 'REFUND',
}

export type Brand = {
  __typename?: 'Brand';
  companyName?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  supportEmail?: Maybe<Scalars['String']['output']>;
};

export type BrandInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
};

export type Buyer = {
  __typename?: 'Buyer';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  province: Scalars['String']['output'];
};

export type CheckoutIntent = {
  __typename?: 'CheckoutIntent';
  buyer: Buyer;
  createdAt: Scalars['DateTime']['output'];
  failReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  offer?: Maybe<CheckoutIntentOffer>;
  productUrl: Scalars['URL']['output'];
  quantity: Scalars['Int']['output'];
  state: CheckoutIntentState;
};

export type CheckoutIntentConnection = {
  __typename?: 'CheckoutIntentConnection';
  edges: Array<CheckoutIntentEdge>;
  pageInfo: PageInfo;
};

export type CheckoutIntentEdge = {
  __typename?: 'CheckoutIntentEdge';
  cursor: Scalars['ConnectionCursor']['output'];
  node: CheckoutIntent;
};

export type CheckoutIntentOffer = {
  __typename?: 'CheckoutIntentOffer';
  currency: Currency;
  shippingCents: Scalars['Int']['output'];
  subtotalCents: Scalars['Int']['output'];
  taxCents: Scalars['Int']['output'];
  totalCents: Scalars['Int']['output'];
};

export enum CheckoutIntentState {
  AwaitingConfirmation = 'AWAITING_CONFIRMATION',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  PlacingOrder = 'PLACING_ORDER',
  RetrievingOffer = 'RETRIEVING_OFFER',
}

export type CheckoutIntentsFiltersInput = {
  buyerEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  buyerFirstNames?: InputMaybe<Array<Scalars['String']['input']>>;
  buyerLastNames?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  productUrls?: InputMaybe<Array<Scalars['URL']['input']>>;
  states?: InputMaybe<Array<CheckoutIntentState>>;
};

export enum CheckoutIntentsSortByValue {
  CreatedAt = 'CREATED_AT',
  State = 'STATE',
}

export type CheckoutIntentsSortInput = {
  direction: SortDirectionValue;
  sortBy: CheckoutIntentsSortByValue;
};

export type Commission = {
  __typename?: 'Commission';
  rate: Scalars['Float']['output'];
  status: CommissionStatus;
};

export enum CommissionStatus {
  Discounted = 'DISCOUNTED',
  Pending = 'PENDING',
  Sent = 'SENT',
  Skipped = 'SKIPPED',
}

export type CreateDeveloperTokenInput = {
  developerId: Scalars['ID']['input'];
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** ISO currency code. */
export enum Currency {
  /** United Arab Emirates Dirham. */
  Aed = 'AED',
  /** Afghan Afghani. */
  Afn = 'AFN',
  /** Albanian Lek. */
  All = 'ALL',
  /** Armenian Dram. */
  Amd = 'AMD',
  /** Netherlands Antillean Gulden. */
  Ang = 'ANG',
  /** Angolan Kwanza. */
  Aoa = 'AOA',
  /** Argentine Peso. */
  Ars = 'ARS',
  /** Australian Dollar. */
  Aud = 'AUD',
  /** Aruban Florin. */
  Awg = 'AWG',
  /** Azerbaijani Manat. */
  Azn = 'AZN',
  /** Bosnia and Herzegovina Convertible Mark. */
  Bam = 'BAM',
  /** Barbadian Dollar. */
  Bbd = 'BBD',
  /** Bangladeshi Taka. */
  Bdt = 'BDT',
  /** Bulgarian Lev. */
  Bgn = 'BGN',
  /** Bahraini Dinar. */
  Bhd = 'BHD',
  /** Burundian Franc. */
  Bif = 'BIF',
  /** Bermudian Dollar. */
  Bmd = 'BMD',
  /** Brunei Dollar. */
  Bnd = 'BND',
  /** Bolivian Boliviano. */
  Bob = 'BOB',
  /** Brazilian Real. */
  Brl = 'BRL',
  /** Bahamian Dollar. */
  Bsd = 'BSD',
  /** Bhutanese Ngultrum. */
  Btn = 'BTN',
  /** Botswana Pula. */
  Bwp = 'BWP',
  /** Belarusian Ruble. */
  Byn = 'BYN',
  /** Belarusian Ruble. */
  Byr = 'BYR',
  /** Belize Dollar. */
  Bzd = 'BZD',
  /** Canadian Dollar. */
  Cad = 'CAD',
  /** Congolese Franc. */
  Cdf = 'CDF',
  /** Swiss Franc. */
  Chf = 'CHF',
  /** Unidad de Fomento. */
  Clf = 'CLF',
  /** Chilean Peso. */
  Clp = 'CLP',
  /** Chinese Renminbi Yuan. */
  Cny = 'CNY',
  /** Colombian Peso. */
  Cop = 'COP',
  /** Costa Rican Colón. */
  Crc = 'CRC',
  /** Cuban Convertible Peso. */
  Cuc = 'CUC',
  /** Cuban Peso. */
  Cup = 'CUP',
  /** Cape Verdean Escudo. */
  Cve = 'CVE',
  /** Cypriot pound. */
  Cyp = 'CYP',
  /** Czech Koruna. */
  Czk = 'CZK',
  /** Djiboutian Franc. */
  Djf = 'DJF',
  /** Danish Krone. */
  Dkk = 'DKK',
  /** Dominican Peso. */
  Dop = 'DOP',
  /** Algerian Dinar. */
  Dzd = 'DZD',
  /** Estonian Kroon. */
  Eek = 'EEK',
  /** Egyptian Pound. */
  Egp = 'EGP',
  /** Eritrean Nakfa. */
  Ern = 'ERN',
  /** Ethiopian Birr. */
  Etb = 'ETB',
  /** Euro. */
  Eur = 'EUR',
  /** Fijian Dollar. */
  Fjd = 'FJD',
  /** Falkland Pound. */
  Fkp = 'FKP',
  /** British Pound. */
  Gbp = 'GBP',
  /** British Penny. */
  Gbx = 'GBX',
  /** Georgian Lari. */
  Gel = 'GEL',
  /** Guernsey Pound. */
  Ggp = 'GGP',
  /** Ghanaian Cedi. */
  Ghc = 'GHC',
  /** Ghanaian Cedi. */
  Ghs = 'GHS',
  /** Gibraltar Pound. */
  Gip = 'GIP',
  /** Gambian Dalasi. */
  Gmd = 'GMD',
  /** Guinean Franc. */
  Gnf = 'GNF',
  /** Guatemalan Quetzal. */
  Gtq = 'GTQ',
  /** Guyanese Dollar. */
  Gyd = 'GYD',
  /** Hong Kong Dollar. */
  Hkd = 'HKD',
  /** Honduran Lempira. */
  Hnl = 'HNL',
  /** Croatian Kuna. */
  Hrk = 'HRK',
  /** Haitian Gourde. */
  Htg = 'HTG',
  /** Hungarian Forint. */
  Huf = 'HUF',
  /** Indonesian Rupiah. */
  Idr = 'IDR',
  /** Israeli New Sheqel. */
  Ils = 'ILS',
  /** Isle of Man Pound. */
  Imp = 'IMP',
  /** Indian Rupee. */
  Inr = 'INR',
  /** Iraqi Dinar. */
  Iqd = 'IQD',
  /** Iranian Rial. */
  Irr = 'IRR',
  /** Icelandic Króna. */
  Isk = 'ISK',
  /** Jersey Pound. */
  Jep = 'JEP',
  /** Jamaican Dollar. */
  Jmd = 'JMD',
  /** Jordanian Dinar. */
  Jod = 'JOD',
  /** Japanese Yen. */
  Jpy = 'JPY',
  /** Kenyan Shilling. */
  Kes = 'KES',
  /** Kyrgyzstani Som. */
  Kgs = 'KGS',
  /** Cambodian Riel. */
  Khr = 'KHR',
  /** Kiribati Dollar. */
  Kid = 'KID',
  /** Comorian Franc. */
  Kmf = 'KMF',
  /** North Korean Won. */
  Kpw = 'KPW',
  /** South Korean Won. */
  Krw = 'KRW',
  /** Kuwaiti Dinar. */
  Kwd = 'KWD',
  /** Cayman Islands Dollar. */
  Kyd = 'KYD',
  /** Kazakhstani Tenge. */
  Kzt = 'KZT',
  /** Lao Kip. */
  Lak = 'LAK',
  /** Lebanese Pound. */
  Lbp = 'LBP',
  /** Sri Lankan Rupee. */
  Lkr = 'LKR',
  /** Liberian Dollar. */
  Lrd = 'LRD',
  /** Lesotho Loti. */
  Lsl = 'LSL',
  /** Lithuanian Litas. */
  Ltl = 'LTL',
  /** Latvian Lats. */
  Lvl = 'LVL',
  /** Libyan Dinar. */
  Lyd = 'LYD',
  /** Moroccan Dirham. */
  Mad = 'MAD',
  /** Moldovan Leu. */
  Mdl = 'MDL',
  /** Malagasy Ariary. */
  Mga = 'MGA',
  /** Macedonian Denar. */
  Mkd = 'MKD',
  /** Myanmar Kyat. */
  Mmk = 'MMK',
  /** Mongolian Tögrög. */
  Mnt = 'MNT',
  /** Macanese Pataca. */
  Mop = 'MOP',
  /** Mauritanian Ouguiya. */
  Mro = 'MRO',
  /** Mauritanian New Ouguiya. */
  Mru = 'MRU',
  /** Maltese Lira. */
  Mtl = 'MTL',
  /** Mauritian Rupee. */
  Mur = 'MUR',
  /** Maldivian Rufiyaa. */
  Mvr = 'MVR',
  /** Malawian Kwacha. */
  Mwk = 'MWK',
  /** Mexican Peso. */
  Mxn = 'MXN',
  /** Malaysian Ringgit. */
  Myr = 'MYR',
  /** Mozambican Metical. */
  Mzn = 'MZN',
  /** Namibian Dollar. */
  Nad = 'NAD',
  /** Nigerian Naira. */
  Ngn = 'NGN',
  /** Nicaraguan Córdoba. */
  Nio = 'NIO',
  /** Norwegian Krone. */
  Nok = 'NOK',
  /** Nepalese Rupee. */
  Npr = 'NPR',
  /** New Zealand Dollar. */
  Nzd = 'NZD',
  /** Omani Rial. */
  Omr = 'OMR',
  /** Panamanian Balboa. */
  Pab = 'PAB',
  /** Peruvian Sol. */
  Pen = 'PEN',
  /** Papua New Guinean Kina. */
  Pgk = 'PGK',
  /** Philippine Peso. */
  Php = 'PHP',
  /** Pakistani Rupee. */
  Pkr = 'PKR',
  /** Polish Złoty. */
  Pln = 'PLN',
  /** Paraguayan Guaraní. */
  Pyg = 'PYG',
  /** Qatari Riyal. */
  Qar = 'QAR',
  /** Romanian Leu. */
  Ron = 'RON',
  /** Serbian Dinar. */
  Rsd = 'RSD',
  /** Russian Ruble. */
  Rub = 'RUB',
  /** Rwandan Franc. */
  Rwf = 'RWF',
  /** Saudi Riyal. */
  Sar = 'SAR',
  /** Solomon Islands Dollar. */
  Sbd = 'SBD',
  /** Seychellois Rupee. */
  Scr = 'SCR',
  /** Sudanese Pound. */
  Sdg = 'SDG',
  /** Swedish Krona. */
  Sek = 'SEK',
  /** Singapore Dollar. */
  Sgd = 'SGD',
  /** Saint Helenian Pound. */
  Shp = 'SHP',
  /** Slovak Koruna. */
  Skk = 'SKK',
  /** Sierra Leonean Leone. */
  Sll = 'SLL',
  /** Somali Shilling. */
  Sos = 'SOS',
  /** Surinamese Dollar. */
  Srd = 'SRD',
  /** South Sudanese Pound. */
  Ssp = 'SSP',
  /** São Tomé and Príncipe Dobra. */
  Std = 'STD',
  /** Salvadoran Colón. */
  Svc = 'SVC',
  /** Syrian Pound. */
  Syp = 'SYP',
  /** Swazi Lilangeni. */
  Szl = 'SZL',
  /** Thai Baht. */
  Thb = 'THB',
  /** Tajikistani Somoni. */
  Tjs = 'TJS',
  /** Turkmenistani Manat. */
  Tmm = 'TMM',
  /** Turkmenistani Manat. */
  Tmt = 'TMT',
  /** Tunisian Dinar. */
  Tnd = 'TND',
  /** Tongan Paʻanga. */
  Top = 'TOP',
  /** Turkish Lira. */
  Try = 'TRY',
  /** Trinidad and Tobago Dollar. */
  Ttd = 'TTD',
  /** New Taiwan Dollar. */
  Twd = 'TWD',
  /** Tanzanian Shilling. */
  Tzs = 'TZS',
  /** Ukrainian Hryvnia. */
  Uah = 'UAH',
  /** Ugandan Shilling. */
  Ugx = 'UGX',
  /** United States Dollar. */
  Usd = 'USD',
  /** Uruguayan Peso. */
  Uyu = 'UYU',
  /** Uzbekistan Som. */
  Uzs = 'UZS',
  /** Venezuelan Bolívar. */
  Veb = 'VEB',
  /** Venezuelan Bolívar fuerte. */
  Vef = 'VEF',
  /** Venezuelan Bolívar soberano. */
  Ves = 'VES',
  /** Vietnamese Đồng. */
  Vnd = 'VND',
  /** Vanuatu Vatu. */
  Vuv = 'VUV',
  /** Samoan Tala. */
  Wst = 'WST',
  /** Central African Cfa Franc. */
  Xaf = 'XAF',
  /** Silver (Troy Ounce). */
  Xag = 'XAG',
  /** Gold (Troy Ounce). */
  Xau = 'XAU',
  /** European Composite Unit. */
  Xba = 'XBA',
  /** European Monetary Unit. */
  Xbb = 'XBB',
  /** European Unit of Account 9. */
  Xbc = 'XBC',
  /** European Unit of Account 17. */
  Xbd = 'XBD',
  /** East Caribbean Dollar. */
  Xcd = 'XCD',
  /** Special Drawing Rights. */
  Xdr = 'XDR',
  /** UIC Franc. */
  Xfu = 'XFU',
  /** West African Cfa Franc. */
  Xof = 'XOF',
  /** Palladium. */
  Xpd = 'XPD',
  /** Cfp Franc. */
  Xpf = 'XPF',
  /** Platinum. */
  Xpt = 'XPT',
  /** Codes specifically reserved for testing purposes. */
  Xts = 'XTS',
  /** Yemeni Rial. */
  Yer = 'YER',
  /** South African Rand. */
  Zar = 'ZAR',
  /** Zambian Kwacha. */
  Zmk = 'ZMK',
  /** Zambian Kwacha. */
  Zmw = 'ZMW',
  /** Zimbabwean Dollar. */
  Zwd = 'ZWD',
  /** Zimbabwean Dollar. */
  Zwl = 'ZWL',
  /** Zimbabwean Dollar. */
  Zwn = 'ZWN',
  /** Zimbabwean Dollar. */
  Zwr = 'ZWR',
}

export type CursorPaginationInput = {
  after?: InputMaybe<Scalars['ConnectionCursor']['input']>;
  before?: InputMaybe<Scalars['ConnectionCursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Developer = {
  __typename?: 'Developer';
  displayName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  photoURL?: Maybe<Scalars['String']['output']>;
};

export type DeveloperTokenResponse = {
  __typename?: 'DeveloperTokenResponse';
  error?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type DevelopersResponse = {
  __typename?: 'DevelopersResponse';
  developers?: Maybe<Array<Developer>>;
  error?: Maybe<Scalars['String']['output']>;
};

export type ExportBillingItemsInput = {
  additionalRecipients?: InputMaybe<Array<Scalars['Email']['input']>>;
  columns: Array<ExportColumns>;
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type ExportBillingItemsResponse = {
  __typename?: 'ExportBillingItemsResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum ExportColumns {
  AffiliateCommission = 'AFFILIATE_COMMISSION',
  AffiliateCommissionPayer = 'AFFILIATE_COMMISSION_PAYER',
  CommissionDev = 'COMMISSION_DEV',
  CommissionPayer = 'COMMISSION_PAYER',
  CommissionRye = 'COMMISSION_RYE',
  CommissionStatus = 'COMMISSION_STATUS',
  CommissionTotal = 'COMMISSION_TOTAL',
  Credit = 'CREDIT',
  Currency = 'CURRENCY',
  Date = 'DATE',
  Discount = 'DISCOUNT',
  DiscountCodes = 'DISCOUNT_CODES',
  DiscountCommission = 'DISCOUNT_COMMISSION',
  DiscountCommissionDev = 'DISCOUNT_COMMISSION_DEV',
  DiscountCommissionPayer = 'DISCOUNT_COMMISSION_PAYER',
  DiscountCommissionRye = 'DISCOUNT_COMMISSION_RYE',
  DiscountUsd = 'DISCOUNT_USD',
  FulfillmentFee = 'FULFILLMENT_FEE',
  ItemNames = 'ITEM_NAMES',
  Margin = 'MARGIN',
  MarginUsd = 'MARGIN_USD',
  MarkupCommission = 'MARKUP_COMMISSION',
  MarkupCommissionDev = 'MARKUP_COMMISSION_DEV',
  MarkupCommissionPayer = 'MARKUP_COMMISSION_PAYER',
  MarkupCommissionRye = 'MARKUP_COMMISSION_RYE',
  OrderId = 'ORDER_ID',
  PlatformFee = 'PLATFORM_FEE',
  Refund = 'REFUND',
  RyeServiceFee = 'RYE_SERVICE_FEE',
  Shipping = 'SHIPPING',
  ShippingUsd = 'SHIPPING_USD',
  StoreName = 'STORE_NAME',
  StoreUrl = 'STORE_URL',
  Subtotal = 'SUBTOTAL',
  SubtotalUsd = 'SUBTOTAL_USD',
  Tax = 'TAX',
  TaxUsd = 'TAX_USD',
  ThankYouPage = 'THANK_YOU_PAGE',
  Total = 'TOTAL',
  TotalUsd = 'TOTAL_USD',
}

export type GmvTier = {
  __typename?: 'GMVTier';
  max?: Maybe<Scalars['Int']['output']>;
  min: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  tier: Scalars['Int']['output'];
};

export type Image = {
  __typename?: 'Image';
  url: Scalars['URL']['output'];
};

export type InventoryRequest = {
  __typename?: 'InventoryRequest';
  data: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  requestType: Scalars['String']['output'];
  requestedAt: Scalars['DateTime']['output'];
};

export type InventoryRequestConnection = {
  __typename?: 'InventoryRequestConnection';
  edges: Array<InventoryRequestEdge>;
};

export type InventoryRequestEdge = {
  __typename?: 'InventoryRequestEdge';
  cursor: Scalars['ConnectionCursor']['output'];
  node: InventoryRequest;
};

export type InventoryRequestLimits = {
  __typename?: 'InventoryRequestLimits';
  uniqueProductRequests?: Maybe<Scalars['Int']['output']>;
  uniqueStoreRequests?: Maybe<Scalars['Int']['output']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  amount: Amount;
  billingPeriod: InvoiceBillingPeriod;
  chargeDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  items: Array<InvoiceItem>;
  number: Scalars['String']['output'];
  status: InvoiceStatus;
};

export type InvoiceBillingPeriod = {
  __typename?: 'InvoiceBillingPeriod';
  endDate: Scalars['DateTime']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type InvoiceEdge = {
  __typename?: 'InvoiceEdge';
  cursor: Scalars['ConnectionCursor']['output'];
  node: Invoice;
};

export type InvoiceFiltersInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  amount: Amount;
  description: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type InvoicePaginationInput = {
  after?: InputMaybe<Scalars['ConnectionCursor']['input']>;
  before?: InputMaybe<Scalars['ConnectionCursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum InvoiceStatus {
  Draft = 'DRAFT',
  Paid = 'PAID',
  Unpaid = 'UNPAID',
  Void = 'VOID',
}

export type InvoicesResponse = {
  __typename?: 'InvoicesResponse';
  edges: Array<InvoiceEdge>;
  pageInfo: PageInfo;
};

export type MarginInput = {
  amount: Scalars['Float']['input'];
  isPercent: Scalars['Boolean']['input'];
};

export enum Marketplace {
  Amazon = 'AMAZON',
  Shopify = 'SHOPIFY',
}

export type Merchant = {
  __typename?: 'Merchant';
  commissionRate: Scalars['Float']['output'];
  commissionType: MerchantCommissionType;
  deliverabilitySupport: MerchantDeliverabilitySupportStatus;
  domain: Scalars['Domain']['output'];
  id: Scalars['ID']['output'];
  /** The merchant's integration status, from the perspective of the authenticated user */
  integrationStatus: MerchantIntegrationStatusType;
  logo?: Maybe<Scalars['URL']['output']>;
  name: Scalars['String']['output'];
};

export enum MerchantCommissionType {
  Discount = 'DISCOUNT',
  Standard = 'STANDARD',
}

export enum MerchantDeliverabilitySupportStatus {
  /** All delivery options offered by this merchant are supported by Rye. */
  Full = 'FULL',
  /** Some delivery options offered by this merchant are supported by Rye. */
  Partial = 'PARTIAL',
  /** The merchant's deliverability support status is unknown at this time. */
  Unknown = 'UNKNOWN',
}

export enum MerchantIntegrationStatusType {
  /** The merchant is directly integrated with the authenticated user. */
  DirectlyIntegrated = 'DIRECTLY_INTEGRATED',
  /** The merchant is integrated with Rye, but not directly with the authenticated user. */
  Integrated = 'INTEGRATED',
  /**
   * The merchant is either not integrated with Rye, or the authenticated user does
   * not have permission to access the merchant in an integrated manner.
   */
  NonIntegrated = 'NON_INTEGRATED',
}

export type MerchantsByDeveloperResponse = {
  __typename?: 'MerchantsByDeveloperResponse';
  merchants: Array<Merchant>;
};

/** Mutations to perform actions with Rye's admin API */
export type Mutation = {
  __typename?: 'Mutation';
  /** Create a new payment method */
  attachPaymentMethod: AttachPaymentMethodResponse;
  authorizeAmazonBusiness: AuthorizeAmazonBusinessResponse;
  /** Admin mutation to get custom token for logging into another developers account */
  createDeveloperToken: DeveloperTokenResponse;
  /** Admin mutation to kick of the process of exporting billing items */
  exportBillingItems: ExportBillingItemsResponse;
  /** Admin mutation to reactivate the developer's plan */
  reactivatePlan: ReactivatePlanResponse;
  /**
   * Rotate the API key. Generates a new primary key and demotes the current
   * primary to secondary. Any existing secondary key is replaced.
   */
  regenerateApiKey: UserResponse;
  /** Revoke (delete) the secondary API key. Only the primary key remains valid. */
  revokeSecondaryApiKey: UserResponse;
  /** Save a new webhook url */
  saveWebhookURL: SaveWebhookUrlResponse;
  /**
   * Sends a test webhook to the developer's webhook endpoint.
   *
   * This mutation is a no-op in staging.
   */
  sendTestWebhook: SendTestWebhookResponse;
  /** Update Amazon Business account */
  updateAmazonBusinessAccount: UserResponse;
  /** Updates the billing notification settings for a user */
  updateBillingNotifications: UpdateBillingNotificationsResponse;
  /** Update the developer's brand settings */
  updateBrand: UserResponse;
  /** Update user */
  updateUser: UserResponse;
};

/** Mutations to perform actions with Rye's admin API */
export type MutationAttachPaymentMethodArgs = {
  input: AttachPaymentMethodInput;
};

/** Mutations to perform actions with Rye's admin API */
export type MutationAuthorizeAmazonBusinessArgs = {
  input?: InputMaybe<AuthorizeAmazonBusinessInput>;
};

/** Mutations to perform actions with Rye's admin API */
export type MutationCreateDeveloperTokenArgs = {
  input: CreateDeveloperTokenInput;
};

/** Mutations to perform actions with Rye's admin API */
export type MutationExportBillingItemsArgs = {
  input: ExportBillingItemsInput;
};

/** Mutations to perform actions with Rye's admin API */
export type MutationSaveWebhookUrlArgs = {
  input: SaveWebhookUrlInput;
};

/** Mutations to perform actions with Rye's admin API */
export type MutationSendTestWebhookArgs = {
  input: SendTestWebhookInput;
};

/** Mutations to perform actions with Rye's admin API */
export type MutationUpdateAmazonBusinessAccountArgs = {
  input: AmazonBusinessAccountInput;
};

/** Mutations to perform actions with Rye's admin API */
export type MutationUpdateBillingNotificationsArgs = {
  input: UpdateBillingNotificationsInput;
};

/** Mutations to perform actions with Rye's admin API */
export type MutationUpdateBrandArgs = {
  input: BrandInput;
};

/** Mutations to perform actions with Rye's admin API */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  billingNotifications: BillingNotifications;
};

export type OffsetPaginationInput = {
  /** The number of items to fetch per page. The maximum value is 100. */
  limit?: Scalars['Int']['input'];
  /** The number of items to skip from the beginning of the list. */
  offset?: Scalars['Int']['input'];
};

export type Order = {
  __typename?: 'Order';
  api: ApiType;
  breakdown?: Maybe<OrderBreakdown>;
  commission?: Maybe<Commission>;
  id: Scalars['ID']['output'];
  marketplace: Marketplace;
  marketplaceOrderIds: Array<Scalars['String']['output']>;
  products: Array<OrderProduct>;
  transfers: Array<BillingTransfer>;
};

export type OrderAmazonProduct = OrderProduct & {
  __typename?: 'OrderAmazonProduct';
  productId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type OrderBreakdown = {
  __typename?: 'OrderBreakdown';
  currency: Currency;
  discountCents: Scalars['Int']['output'];
  marginCents: Scalars['Int']['output'];
  refundCents: Scalars['Int']['output'];
  shippingCents: Scalars['Int']['output'];
  subtotalCents: Scalars['Int']['output'];
  taxCents: Scalars['Int']['output'];
  totalCents: Scalars['Int']['output'];
};

export type OrderProduct = {
  productId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type OrderShopifyProduct = OrderProduct & {
  __typename?: 'OrderShopifyProduct';
  productId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  storeCanonicalURL: Scalars['String']['output'];
  title: Scalars['String']['output'];
  variantId: Scalars['String']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['ConnectionCursor']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  startCursor?: Maybe<Scalars['ConnectionCursor']['output']>;
};

export type PaginationInput = {
  after?: InputMaybe<Scalars['ConnectionCursor']['input']>;
  before?: InputMaybe<Scalars['ConnectionCursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentMethod = PaymentMethodAch | PaymentMethodCard | PaymentMethodUnknown;

export type PaymentMethodAch = {
  __typename?: 'PaymentMethodACH';
  bank: Scalars['String']['output'];
  last4AccountNumber: Scalars['String']['output'];
};

export type PaymentMethodCard = {
  __typename?: 'PaymentMethodCard';
  brand: Scalars['String']['output'];
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  last4: Scalars['String']['output'];
};

export type PaymentMethodUnknown = {
  __typename?: 'PaymentMethodUnknown';
  brand: Scalars['String']['output'];
};

/** Microdeposit verification still required for a US bank account. */
export type PendingMicrodepositVerification = {
  __typename?: 'PendingMicrodepositVerification';
  /** Hosted page where the account holder confirms the microdeposit. */
  hostedVerificationUrl: Scalars['String']['output'];
};

export type Product = {
  currency: Currency;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Image>>;
  isAvailable: Scalars['Boolean']['output'];
  price: Scalars['Int']['output'];
  store: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['URL']['output'];
};

export enum ProductAvailabilityValue {
  InStock = 'IN_STOCK',
  OutOfStock = 'OUT_OF_STOCK',
}

export type ProductConnection = {
  __typename?: 'ProductConnection';
  edges: Array<ProductEdge>;
  pageInfo: PageInfo;
};

export type ProductEdge = {
  __typename?: 'ProductEdge';
  cursor: Scalars['ConnectionCursor']['output'];
  node: Product;
};

export type ProductsFilterInput = {
  availability?: InputMaybe<ProductAvailabilityValue>;
  currencies?: InputMaybe<Array<Currency>>;
  marketplaces?: InputMaybe<Array<Marketplace>>;
  maxPrice?: InputMaybe<Scalars['Int']['input']>;
  minPrice?: InputMaybe<Scalars['Int']['input']>;
  storeDomains?: InputMaybe<Array<Scalars['Domain']['input']>>;
};

export enum ProductsSortByValue {
  Price = 'PRICE',
  Store = 'STORE',
  Vendor = 'VENDOR',
}

export type ProductsSortInput = {
  direction: SortDirectionValue;
  sortBy: ProductsSortByValue;
};

/** Query operations to look up data within Rye's admin API */
export type Query = {
  __typename?: 'Query';
  amazonBusinessAuthStatus: AmazonBusinessAuthStatusResponse;
  billingItems: BillingItemResponse;
  checkoutIntents: CheckoutIntentConnection;
  developers: DevelopersResponse;
  inventoryRequests: InventoryRequestConnection;
  invoices: InvoicesResponse;
  merchantByDomain?: Maybe<Merchant>;
  merchantsByDeveloper: MerchantsByDeveloperResponse;
  orderById: Order;
  productInventoryRequestsCount: Scalars['Int']['output'];
  products: ProductConnection;
  storeInventoryRequestsCount: Scalars['Int']['output'];
  stores: StoreConnection;
  totalStores: TotalStoresResponse;
  user: UserResponse;
};

/** Query operations to look up data within Rye's admin API */
export type QueryBillingItemsArgs = {
  filters?: InputMaybe<BillingFiltersInput>;
  pagination?: InputMaybe<BillingItemsPaginationInput>;
};

/** Query operations to look up data within Rye's admin API */
export type QueryCheckoutIntentsArgs = {
  filters?: InputMaybe<CheckoutIntentsFiltersInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<CheckoutIntentsSortInput>;
};

/** Query operations to look up data within Rye's admin API */
export type QueryInvoicesArgs = {
  filters?: InputMaybe<InvoiceFiltersInput>;
  pagination?: InputMaybe<InvoicePaginationInput>;
};

/** Query operations to look up data within Rye's admin API */
export type QueryMerchantByDomainArgs = {
  domain: Scalars['Domain']['input'];
};

/** Query operations to look up data within Rye's admin API */
export type QueryOrderByIdArgs = {
  id: Scalars['ID']['input'];
};

/** Query operations to look up data within Rye's admin API */
export type QueryProductsArgs = {
  filters?: InputMaybe<ProductsFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
  sort?: InputMaybe<ProductsSortInput>;
};

/** Query operations to look up data within Rye's admin API */
export type QueryStoresArgs = {
  filters?: InputMaybe<StoresFiltersInput>;
  pagination?: InputMaybe<PaginationInput>;
};

/** Query operations to look up data within Rye's admin API */
export type QueryTotalStoresArgs = {
  filters?: InputMaybe<StoresFiltersInput>;
};

export type ReactivatePlanResponse = {
  __typename?: 'ReactivatePlanResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SaveWebhookUrlInput = {
  url: Scalars['String']['input'];
};

export type SaveWebhookUrlResponse = {
  __typename?: 'SaveWebhookURLResponse';
  url: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
};

/** Input for sending a test webhook. Only one field of this object should be provided. */
export type SendTestWebhookInput = {
  /** Send an order webhook. */
  orderEvent?: InputMaybe<SendTestWebhookOrderEventInput>;
  /** Send a product webhook for the first product inside an order. */
  orderProductEvent?: InputMaybe<SendTestWebhookProductEventInput>;
};

export type SendTestWebhookOrderEventInput = {
  /** Order ID to send the webhook for. */
  orderId: Scalars['ID']['input'];
  /** Event type to send. e.g. `ORDER_SUBMISSION_STARTED` */
  type: Scalars['String']['input'];
};

export type SendTestWebhookProductEventInput = {
  /** Order ID to retrieve a product from. */
  orderId: Scalars['ID']['input'];
  /** Event type to send. e.g. `PRODUCT_DELETED` */
  type: Scalars['String']['input'];
};

export type SendTestWebhookResponse = {
  __typename?: 'SendTestWebhookResponse';
  /** ID of the event that was created. */
  id: Scalars['ID']['output'];
};

export type ShopifyProduct = Product & {
  __typename?: 'ShopifyProduct';
  currency: Currency;
  id: Scalars['ID']['output'];
  images: Array<Image>;
  isAvailable: Scalars['Boolean']['output'];
  price: Scalars['Int']['output'];
  store: Scalars['String']['output'];
  storeCommissions?: Maybe<Scalars['Float']['output']>;
  storeDomain: Scalars['Domain']['output'];
  storeLogo?: Maybe<Scalars['URL']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['URL']['output'];
  vendor: Scalars['String']['output'];
};

export enum SortDirectionValue {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type Store = {
  __typename?: 'Store';
  commissionRatePercent: Scalars['Float']['output'];
  domain: Scalars['Domain']['output'];
  id: Scalars['ID']['output'];
  integrationType: StoreIntegrationType;
  isLive: Scalars['Boolean']['output'];
  logoUrl?: Maybe<Scalars['URL']['output']>;
  marketplace: Marketplace;
  name: Scalars['String']['output'];
};

export type StoreConnection = {
  __typename?: 'StoreConnection';
  edges: Array<StoreEdge>;
  pageInfo: PageInfo;
};

export type StoreEdge = {
  __typename?: 'StoreEdge';
  cursor: Scalars['ConnectionCursor']['output'];
  node: Store;
};

export enum StoreIntegrationType {
  Integrated = 'INTEGRATED',
  NonIntegrated = 'NON_INTEGRATED',
}

export type StoresFiltersInput = {
  integrationType?: InputMaybe<StoreIntegrationType>;
  isLive?: InputMaybe<Scalars['Boolean']['input']>;
  marketplace?: InputMaybe<Marketplace>;
  maxCommissionRatePercent?: InputMaybe<Scalars['Float']['input']>;
  minCommissionRatePercent?: InputMaybe<Scalars['Float']['input']>;
  /** Searches for stores by name or domain */
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type StripeConfig = {
  __typename?: 'StripeConfig';
  customerId: Scalars['String']['output'];
  paymentMethod?: Maybe<PaymentMethod>;
};

export type TotalStoresResponse = {
  __typename?: 'TotalStoresResponse';
  count: Scalars['Int']['output'];
};

export type UpdateBillingNotificationsInput = {
  emails: Array<Scalars['Email']['input']>;
};

export type UpdateBillingNotificationsResponse = {
  __typename?: 'UpdateBillingNotificationsResponse';
  error?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<BillingNotifications>;
};

export type UpdateUserInput = {
  account?: InputMaybe<UserAccountInput>;
  brand?: InputMaybe<BrandInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  adminToken?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported and will be removed after migration */
  amazonGroupId?: Maybe<Scalars['String']['output']>;
  apiKey: Scalars['String']['output'];
  apiKeySecondary?: Maybe<Scalars['String']['output']>;
  authProvider: AuthProvider;
  brand?: Maybe<Brand>;
  displayName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  hmacSecretKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inventoryRequestLimits?: Maybe<InventoryRequestLimits>;
  isApprovedForDirectCheckout?: Maybe<Scalars['Boolean']['output']>;
  jwtValidationKey?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  marginAmount?: Maybe<Scalars['Float']['output']>;
  marginIsPercent?: Maybe<Scalars['Boolean']['output']>;
  photoURL?: Maybe<Scalars['String']['output']>;
  webhookURL?: Maybe<Scalars['String']['output']>;
  webhookURLVerified?: Maybe<Scalars['Boolean']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type UserAccountInput = {
  jwtValidationKey?: InputMaybe<Scalars['String']['input']>;
  margin?: InputMaybe<MarginInput>;
};

export type UserData = {
  __typename?: 'UserData';
  accessScopes: Array<Scalars['String']['output']>;
  amazonBusinessAccount?: Maybe<AmazonBusinessAccount>;
  billingPeriodSettings: BillingPeriodSettings;
  notificationSettings: NotificationSettings;
  stripeConfig: StripeConfig;
  user: User;
};

export type UserResponse = {
  __typename?: 'UserResponse';
  data?: Maybe<UserData>;
  error?: Maybe<Scalars['String']['output']>;
};

export type VolumeTier = {
  __typename?: 'VolumeTier';
  fee: Scalars['Float']['output'];
  volume: Scalars['Int']['output'];
};

export type AttachPaymentMethodMutationVariables = Exact<{
  input: AttachPaymentMethodInput;
}>;

export type AttachPaymentMethodMutation = {
  __typename?: 'Mutation';
  attachPaymentMethod: {
    __typename?: 'AttachPaymentMethodResponse';
    stripeConfig: {
      __typename?: 'StripeConfig';
      customerId: string;
      paymentMethod?:
        | { __typename?: 'PaymentMethodACH'; last4AccountNumber: string; bank: string }
        | {
            __typename?: 'PaymentMethodCard';
            last4: string;
            brand: string;
            expMonth: number;
            expYear: number;
          }
        | { __typename?: 'PaymentMethodUnknown'; brand: string }
        | null;
    };
    pendingMicrodepositVerification?: {
      __typename?: 'PendingMicrodepositVerification';
      hostedVerificationUrl: string;
    } | null;
  };
};

export type MerchantByDomainQueryVariables = Exact<{
  domain: Scalars['Domain']['input'];
}>;

export type MerchantByDomainQuery = {
  __typename?: 'Query';
  merchantByDomain?: {
    __typename?: 'Merchant';
    id: string;
    integrationStatus: MerchantIntegrationStatusType;
  } | null;
};

export type UpdateBillingNotificationsMutationVariables = Exact<{
  input: UpdateBillingNotificationsInput;
}>;

export type UpdateBillingNotificationsMutation = {
  __typename?: 'Mutation';
  updateBillingNotifications: {
    __typename?: 'UpdateBillingNotificationsResponse';
    error?: string | null;
    settings?: { __typename?: 'BillingNotifications'; emails?: Array<string> | null } | null;
  };
};

export type SendTestWebhookMutationVariables = Exact<{
  input: SendTestWebhookInput;
}>;

export type SendTestWebhookMutation = {
  __typename?: 'Mutation';
  sendTestWebhook: { __typename?: 'SendTestWebhookResponse'; id: string };
};

export type SaveWebhookUrlMutationVariables = Exact<{
  input: SaveWebhookUrlInput;
}>;

export type SaveWebhookUrlMutation = {
  __typename?: 'Mutation';
  saveWebhookURL: { __typename?: 'SaveWebhookURLResponse'; url: string; verified: boolean };
};

export type MerchantsByDeveloperQueryVariables = Exact<{ [key: string]: never }>;

export type MerchantsByDeveloperQuery = {
  __typename?: 'Query';
  merchantsByDeveloper: {
    __typename?: 'MerchantsByDeveloperResponse';
    merchants: Array<{
      __typename?: 'Merchant';
      commissionRate: number;
      commissionType: MerchantCommissionType;
      deliverabilitySupport: MerchantDeliverabilitySupportStatus;
      domain: any;
      logo?: any | null;
      name: string;
    }>;
  };
};

export type StoresQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filters?: InputMaybe<StoresFiltersInput>;
}>;

export type StoresQuery = {
  __typename?: 'Query';
  stores: {
    __typename?: 'StoreConnection';
    edges: Array<{
      __typename?: 'StoreEdge';
      cursor: string;
      node: {
        __typename?: 'Store';
        id: string;
        domain: any;
        name: string;
        marketplace: Marketplace;
        logoUrl?: any | null;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export type TotalStoresQueryVariables = Exact<{
  filters?: InputMaybe<StoresFiltersInput>;
}>;

export type TotalStoresQuery = {
  __typename?: 'Query';
  totalStores: { __typename?: 'TotalStoresResponse'; count: number };
};

export type BillingItemsQueryVariables = Exact<{
  pagination?: InputMaybe<BillingItemsPaginationInput>;
  filters?: InputMaybe<BillingFiltersInput>;
}>;

export type BillingItemsQuery = {
  __typename?: 'Query';
  billingItems: {
    __typename?: 'BillingItemResponse';
    edges: Array<{
      __typename?: 'BillingItemEdge';
      cursor: string;
      node: {
        __typename?: 'BillingItem';
        createdAt: string;
        id: string;
        orderId: string;
        type: BillingItemType;
        payer: BillingItemParty;
        receiver: BillingItemParty;
        amount: { __typename?: 'Amount'; currency: Currency; value: number };
        billingSetting: {
          __typename?: 'BillingSetting';
          developerCommissionShare: number;
          merchantCommissionRate: number;
          gmvTier: {
            __typename?: 'GMVTier';
            min: number;
            max?: number | null;
            percentage: number;
            tier: number;
          };
          volumeTiers: Array<{ __typename?: 'VolumeTier'; volume: number; fee: number }>;
        };
      };
    }>;
    pageInfo: {
      __typename?: 'BillingPageInfo';
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: string | null;
      endCursor?: string | null;
      totalPages?: number | null;
    };
  };
};

export type InvoicesQueryVariables = Exact<{
  pagination?: InputMaybe<InvoicePaginationInput>;
  filters?: InputMaybe<InvoiceFiltersInput>;
}>;

export type InvoicesQuery = {
  __typename?: 'Query';
  invoices: {
    __typename?: 'InvoicesResponse';
    edges: Array<{
      __typename?: 'InvoiceEdge';
      cursor: string;
      node: {
        __typename?: 'Invoice';
        id: string;
        createdAt: string;
        dueDate?: string | null;
        chargeDate?: string | null;
        number: string;
        status: InvoiceStatus;
        amount: { __typename?: 'Amount'; value: number; currency: Currency };
        billingPeriod: { __typename?: 'InvoiceBillingPeriod'; startDate: string; endDate: string };
        items: Array<{
          __typename?: 'InvoiceItem';
          description: string;
          quantity: number;
          amount: { __typename?: 'Amount'; value: number; currency: Currency };
        }>;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export type OrderByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type OrderByIdQuery = {
  __typename?: 'Query';
  orderById: {
    __typename?: 'Order';
    marketplaceOrderIds: Array<string>;
    marketplace: Marketplace;
    breakdown?: {
      __typename?: 'OrderBreakdown';
      subtotalCents: number;
      totalCents: number;
      taxCents: number;
      discountCents: number;
      marginCents: number;
      currency: Currency;
      shippingCents: number;
      refundCents: number;
    } | null;
    commission?: { __typename?: 'Commission'; rate: number; status: CommissionStatus } | null;
    products: Array<
      | { __typename?: 'OrderAmazonProduct'; productId: string; quantity: number }
      | {
          __typename?: 'OrderShopifyProduct';
          variantId: string;
          title: string;
          storeCanonicalURL: string;
          productId: string;
          quantity: number;
        }
    >;
  };
};

export type CreateDeveloperTokenMutationVariables = Exact<{
  input: CreateDeveloperTokenInput;
}>;

export type CreateDeveloperTokenMutation = {
  __typename?: 'Mutation';
  createDeveloperToken: {
    __typename?: 'DeveloperTokenResponse';
    token?: string | null;
    error?: string | null;
  };
};

export type DevelopersQueryVariables = Exact<{ [key: string]: never }>;

export type DevelopersQuery = {
  __typename?: 'Query';
  developers: {
    __typename?: 'DevelopersResponse';
    error?: string | null;
    developers?: Array<{
      __typename?: 'Developer';
      id: string;
      email: string;
      displayName?: string | null;
      photoURL?: string | null;
    }> | null;
  };
};

export type ExportBillingItemsMutationVariables = Exact<{
  input: ExportBillingItemsInput;
}>;

export type ExportBillingItemsMutation = {
  __typename?: 'Mutation';
  exportBillingItems: {
    __typename?: 'ExportBillingItemsResponse';
    success: boolean;
    error?: string | null;
  };
};

export type AuthorizeAmazonBusinessMutationVariables = Exact<{
  input: AuthorizeAmazonBusinessInput;
}>;

export type AuthorizeAmazonBusinessMutation = {
  __typename?: 'Mutation';
  authorizeAmazonBusiness: {
    __typename?: 'AuthorizeAmazonBusinessResponse';
    success: boolean;
    error?: string | null;
  };
};

export type CheckoutIntentsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filters?: InputMaybe<CheckoutIntentsFiltersInput>;
  sort?: InputMaybe<CheckoutIntentsSortInput>;
}>;

export type CheckoutIntentsQuery = {
  __typename?: 'Query';
  checkoutIntents: {
    __typename?: 'CheckoutIntentConnection';
    edges: Array<{
      __typename?: 'CheckoutIntentEdge';
      node: {
        __typename?: 'CheckoutIntent';
        id: string;
        state: CheckoutIntentState;
        productUrl: any;
        quantity: number;
        failReason?: string | null;
        createdAt: string;
        buyer: {
          __typename?: 'Buyer';
          firstName: string;
          lastName: string;
          email: string;
          address1: string;
          address2?: string | null;
          city: string;
          province: string;
          country: string;
          postalCode: string;
          phone: string;
        };
        offer?: {
          __typename?: 'CheckoutIntentOffer';
          totalCents: number;
          subtotalCents: number;
          currency: Currency;
          shippingCents: number;
          taxCents: number;
        } | null;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export type ReactivatePlanMutationVariables = Exact<{ [key: string]: never }>;

export type ReactivatePlanMutation = {
  __typename?: 'Mutation';
  reactivatePlan: {
    __typename?: 'ReactivatePlanResponse';
    success: boolean;
    error?: string | null;
  };
};

export type AmazonBusinessAuthStatusQueryVariables = Exact<{ [key: string]: never }>;

export type AmazonBusinessAuthStatusQuery = {
  __typename?: 'Query';
  amazonBusinessAuthStatus: {
    __typename?: 'AmazonBusinessAuthStatusResponse';
    status: AmazonBusinessOauthStatus;
  };
};

export type UpdateBrandMutationVariables = Exact<{
  input: BrandInput;
}>;

export type UpdateBrandMutation = {
  __typename?: 'Mutation';
  updateBrand: {
    __typename?: 'UserResponse';
    error?: string | null;
    data?: {
      __typename?: 'UserData';
      user: {
        __typename?: 'User';
        brand?: {
          __typename?: 'Brand';
          companyName?: string | null;
          supportEmail?: string | null;
          logoUrl?: string | null;
          primaryColor?: string | null;
        } | null;
      };
    } | null;
  };
};

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;

export type UpdateUserMutation = {
  __typename?: 'Mutation';
  updateUser: {
    __typename?: 'UserResponse';
    error?: string | null;
    data?: {
      __typename?: 'UserData';
      user: {
        __typename?: 'User';
        firstName?: string | null;
        lastName?: string | null;
        displayName?: string | null;
        apiKey: string;
        adminToken?: string | null;
        authProvider: AuthProvider;
        email: string;
        id: string;
        webhookURL?: string | null;
        webhookURLVerified?: boolean | null;
        marginAmount?: number | null;
        marginIsPercent?: boolean | null;
        photoURL?: string | null;
        isApprovedForDirectCheckout?: boolean | null;
        website?: string | null;
        jwtValidationKey?: string | null;
        hmacSecretKey?: string | null;
        inventoryRequestLimits?: {
          __typename?: 'InventoryRequestLimits';
          uniqueStoreRequests?: number | null;
          uniqueProductRequests?: number | null;
        } | null;
        brand?: {
          __typename?: 'Brand';
          companyName?: string | null;
          supportEmail?: string | null;
          logoUrl?: string | null;
          primaryColor?: string | null;
        } | null;
      };
      amazonBusinessAccount?: {
        __typename?: 'AmazonBusinessAccount';
        groupId: string;
        buyerEmail: string;
        amazonAccountEmail: string;
        oauthStatus: AmazonBusinessOauthStatus;
      } | null;
      billingPeriodSettings:
        | {
            __typename?: 'BillingMonthly';
            startDate: string;
            endDate: string;
            gracePeriodDays: number;
          }
        | {
            __typename?: 'BillingPrePayment';
            currency: Currency;
            minBalance: number;
            remainingBalance: number;
            lastRefillDate: string;
            startDate: string;
            endDate: string;
            gracePeriodDays: number;
          }
        | {
            __typename?: 'BillingSubscription';
            startDate: string;
            endDate: string;
            status: BillingStatus;
            gracePeriodDays: number;
          };
      stripeConfig: {
        __typename?: 'StripeConfig';
        customerId: string;
        paymentMethod?:
          | { __typename?: 'PaymentMethodACH'; last4AccountNumber: string; bank: string }
          | {
              __typename?: 'PaymentMethodCard';
              last4: string;
              brand: string;
              expMonth: number;
              expYear: number;
            }
          | { __typename?: 'PaymentMethodUnknown'; brand: string }
          | null;
      };
      notificationSettings: {
        __typename?: 'NotificationSettings';
        billingNotifications: {
          __typename?: 'BillingNotifications';
          emails?: Array<string> | null;
        };
      };
    } | null;
  };
};

export type UpdateAmazonBusinessAccountMutationVariables = Exact<{
  input: AmazonBusinessAccountInput;
}>;

export type UpdateAmazonBusinessAccountMutation = {
  __typename?: 'Mutation';
  updateAmazonBusinessAccount: {
    __typename?: 'UserResponse';
    error?: string | null;
    data?: {
      __typename?: 'UserData';
      user: {
        __typename?: 'User';
        firstName?: string | null;
        lastName?: string | null;
        displayName?: string | null;
        apiKey: string;
        adminToken?: string | null;
        authProvider: AuthProvider;
        email: string;
        id: string;
        webhookURL?: string | null;
        webhookURLVerified?: boolean | null;
        marginAmount?: number | null;
        marginIsPercent?: boolean | null;
        photoURL?: string | null;
        isApprovedForDirectCheckout?: boolean | null;
        website?: string | null;
        jwtValidationKey?: string | null;
        hmacSecretKey?: string | null;
        inventoryRequestLimits?: {
          __typename?: 'InventoryRequestLimits';
          uniqueStoreRequests?: number | null;
          uniqueProductRequests?: number | null;
        } | null;
      };
      amazonBusinessAccount?: {
        __typename?: 'AmazonBusinessAccount';
        groupId: string;
        buyerEmail: string;
        amazonAccountEmail: string;
        oauthStatus: AmazonBusinessOauthStatus;
      } | null;
      billingPeriodSettings:
        | {
            __typename?: 'BillingMonthly';
            startDate: string;
            endDate: string;
            gracePeriodDays: number;
          }
        | {
            __typename?: 'BillingPrePayment';
            currency: Currency;
            minBalance: number;
            gracePeriodDays: number;
            remainingBalance: number;
            lastRefillDate: string;
            startDate: string;
            endDate: string;
          }
        | { __typename?: 'BillingSubscription' };
      stripeConfig: {
        __typename?: 'StripeConfig';
        customerId: string;
        paymentMethod?:
          | { __typename?: 'PaymentMethodACH'; last4AccountNumber: string; bank: string }
          | {
              __typename?: 'PaymentMethodCard';
              last4: string;
              brand: string;
              expMonth: number;
              expYear: number;
            }
          | { __typename?: 'PaymentMethodUnknown'; brand: string }
          | null;
      };
      notificationSettings: {
        __typename?: 'NotificationSettings';
        billingNotifications: {
          __typename?: 'BillingNotifications';
          emails?: Array<string> | null;
        };
      };
    } | null;
  };
};

export type UserQueryVariables = Exact<{ [key: string]: never }>;

export type UserQuery = {
  __typename?: 'Query';
  user: {
    __typename?: 'UserResponse';
    error?: string | null;
    data?: {
      __typename?: 'UserData';
      accessScopes: Array<string>;
      user: {
        __typename?: 'User';
        firstName?: string | null;
        lastName?: string | null;
        displayName?: string | null;
        apiKey: string;
        apiKeySecondary?: string | null;
        adminToken?: string | null;
        authProvider: AuthProvider;
        email: string;
        id: string;
        webhookURL?: string | null;
        webhookURLVerified?: boolean | null;
        marginAmount?: number | null;
        marginIsPercent?: boolean | null;
        photoURL?: string | null;
        isApprovedForDirectCheckout?: boolean | null;
        website?: string | null;
        jwtValidationKey?: string | null;
        hmacSecretKey?: string | null;
        inventoryRequestLimits?: {
          __typename?: 'InventoryRequestLimits';
          uniqueStoreRequests?: number | null;
          uniqueProductRequests?: number | null;
        } | null;
        brand?: {
          __typename?: 'Brand';
          companyName?: string | null;
          supportEmail?: string | null;
          logoUrl?: string | null;
          primaryColor?: string | null;
        } | null;
      };
      amazonBusinessAccount?: {
        __typename?: 'AmazonBusinessAccount';
        groupId: string;
        buyerEmail: string;
        amazonAccountEmail: string;
        oauthStatus: AmazonBusinessOauthStatus;
      } | null;
      billingPeriodSettings:
        | {
            __typename?: 'BillingMonthly';
            startDate: string;
            endDate: string;
            gracePeriodDays: number;
          }
        | {
            __typename?: 'BillingPrePayment';
            currency: Currency;
            minBalance: number;
            remainingBalance: number;
            lastRefillDate: string;
            startDate: string;
            endDate: string;
            gracePeriodDays: number;
          }
        | {
            __typename?: 'BillingSubscription';
            startDate: string;
            endDate: string;
            status: BillingStatus;
            gracePeriodDays: number;
          };
      stripeConfig: {
        __typename?: 'StripeConfig';
        customerId: string;
        paymentMethod?:
          | { __typename?: 'PaymentMethodACH'; last4AccountNumber: string; bank: string }
          | {
              __typename?: 'PaymentMethodCard';
              last4: string;
              brand: string;
              expMonth: number;
              expYear: number;
            }
          | { __typename?: 'PaymentMethodUnknown'; brand: string }
          | null;
      };
      notificationSettings: {
        __typename?: 'NotificationSettings';
        billingNotifications: {
          __typename?: 'BillingNotifications';
          emails?: Array<string> | null;
        };
      };
    } | null;
  };
};

export type ProductsQueryVariables = Exact<{
  pagination?: InputMaybe<CursorPaginationInput>;
  filters?: InputMaybe<ProductsFilterInput>;
  sort?: InputMaybe<ProductsSortInput>;
}>;

export type ProductsQuery = {
  __typename?: 'Query';
  products: {
    __typename?: 'ProductConnection';
    edges: Array<{
      __typename?: 'ProductEdge';
      cursor: string;
      node:
        | {
            __typename?: 'AmazonProduct';
            id: string;
            title: string;
            url: any;
            price: number;
            currency: Currency;
            images: Array<{ __typename?: 'Image'; url: any }>;
          }
        | {
            __typename?: 'ShopifyProduct';
            vendor: string;
            store: string;
            storeCommissions?: number | null;
            storeLogo?: any | null;
            id: string;
            title: string;
            url: any;
            price: number;
            currency: Currency;
            images: Array<{ __typename?: 'Image'; url: any }>;
          };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export type InventoryRequestsDataQueryVariables = Exact<{ [key: string]: never }>;

export type InventoryRequestsDataQuery = {
  __typename?: 'Query';
  storeInventoryRequestsCount: number;
  productInventoryRequestsCount: number;
  inventoryRequests: {
    __typename?: 'InventoryRequestConnection';
    edges: Array<{
      __typename?: 'InventoryRequestEdge';
      cursor: string;
      node: {
        __typename?: 'InventoryRequest';
        id: string;
        data: string;
        requestType: string;
        requestedAt: string;
      };
    }>;
  };
};

export type RegenerateApiKeyMutationVariables = Exact<{ [key: string]: never }>;

export type RegenerateApiKeyMutation = {
  __typename?: 'Mutation';
  regenerateApiKey: {
    __typename?: 'UserResponse';
    error?: string | null;
    data?: {
      __typename?: 'UserData';
      user: { __typename?: 'User'; apiKey: string; apiKeySecondary?: string | null };
    } | null;
  };
};

export type RevokeSecondaryApiKeyMutationVariables = Exact<{ [key: string]: never }>;

export type RevokeSecondaryApiKeyMutation = {
  __typename?: 'Mutation';
  revokeSecondaryApiKey: {
    __typename?: 'UserResponse';
    error?: string | null;
    data?: {
      __typename?: 'UserData';
      user: { __typename?: 'User'; apiKey: string; apiKeySecondary?: string | null };
    } | null;
  };
};

export const AttachPaymentMethodDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'attachPaymentMethod' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AttachPaymentMethodInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachPaymentMethod' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stripeConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'customerId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentMethod' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'PaymentMethodCard' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expMonth' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expYear' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'PaymentMethodACH' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'last4AccountNumber' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bank' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'PaymentMethodUnknown' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pendingMicrodepositVerification' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hostedVerificationUrl' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AttachPaymentMethodMutation, AttachPaymentMethodMutationVariables>;
export const MerchantByDomainDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'merchantByDomain' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'domain' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Domain' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'merchantByDomain' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'domain' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'domain' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'integrationStatus' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MerchantByDomainQuery, MerchantByDomainQueryVariables>;
export const UpdateBillingNotificationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateBillingNotifications' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateBillingNotificationsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBillingNotifications' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'emails' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateBillingNotificationsMutation,
  UpdateBillingNotificationsMutationVariables
>;
export const SendTestWebhookDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'sendTestWebhook' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendTestWebhookInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendTestWebhook' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendTestWebhookMutation, SendTestWebhookMutationVariables>;
export const SaveWebhookUrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'saveWebhookURL' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SaveWebhookURLInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveWebhookURL' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'verified' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveWebhookUrlMutation, SaveWebhookUrlMutationVariables>;
export const MerchantsByDeveloperDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'merchantsByDeveloper' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'merchantsByDeveloper' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'merchants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'commissionRate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commissionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deliverabilitySupport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MerchantsByDeveloperQuery, MerchantsByDeveloperQueryVariables>;
export const StoresDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Stores' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'StoresFiltersInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stores' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'marketplace' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StoresQuery, StoresQueryVariables>;
export const TotalStoresDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TotalStores' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'StoresFiltersInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalStores' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TotalStoresQuery, TotalStoresQueryVariables>;
export const BillingItemsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BillingItems' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'BillingItemsPaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'BillingFiltersInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingItems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'payer' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'receiver' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'billingSetting' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'developerCommissionShare' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'merchantCommissionRate' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gmvTier' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'percentage' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'tier' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'volumeTiers' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'volume' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fee' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BillingItemsQuery, BillingItemsQueryVariables>;
export const InvoicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'invoices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'InvoicePaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'InvoiceFiltersInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'invoices' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'billingPeriod' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'chargeDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'items' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'amount' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'currency' },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InvoicesQuery, InvoicesQueryVariables>;
export const OrderByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OrderById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'marketplaceOrderIds' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'breakdown' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'subtotalCents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'taxCents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'discountCents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'marginCents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shippingCents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'refundCents' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'marketplace' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'commission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'products' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'productId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'OrderShopifyProduct' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'variantId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'storeCanonicalURL' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderByIdQuery, OrderByIdQueryVariables>;
export const CreateDeveloperTokenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createDeveloperToken' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateDeveloperTokenInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createDeveloperToken' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateDeveloperTokenMutation, CreateDeveloperTokenMutationVariables>;
export const DevelopersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'developers' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'developers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'developers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'photoURL' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DevelopersQuery, DevelopersQueryVariables>;
export const ExportBillingItemsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'exportBillingItems' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ExportBillingItemsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportBillingItems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExportBillingItemsMutation, ExportBillingItemsMutationVariables>;
export const AuthorizeAmazonBusinessDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'authorizeAmazonBusiness' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AuthorizeAmazonBusinessInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authorizeAmazonBusiness' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AuthorizeAmazonBusinessMutation,
  AuthorizeAmazonBusinessMutationVariables
>;
export const CheckoutIntentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'checkoutIntents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CheckoutIntentsFiltersInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CheckoutIntentsSortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'checkoutIntents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'productUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'failReason' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'buyer' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'province' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'offer' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalCents' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'subtotalCents' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shippingCents' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'taxCents' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CheckoutIntentsQuery, CheckoutIntentsQueryVariables>;
export const ReactivatePlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'reactivatePlan' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reactivatePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReactivatePlanMutation, ReactivatePlanMutationVariables>;
export const AmazonBusinessAuthStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'amazonBusinessAuthStatus' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'amazonBusinessAuthStatus' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AmazonBusinessAuthStatusQuery, AmazonBusinessAuthStatusQueryVariables>;
export const UpdateBrandDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBrand' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BrandInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBrand' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'brand' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'supportEmail' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryColor' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateBrandMutation, UpdateBrandMutationVariables>;
export const UpdateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateUserInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'apiKey' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'adminToken' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'authProvider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'webhookURL' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'webhookURLVerified' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'marginAmount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'marginIsPercent' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'photoURL' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isApprovedForDirectCheckout' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'website' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'inventoryRequestLimits' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'uniqueStoreRequests' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'uniqueProductRequests' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'jwtValidationKey' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hmacSecretKey' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'brand' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'supportEmail' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryColor' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amazonBusinessAccount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buyerEmail' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'amazonAccountEmail' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'oauthStatus' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'billingPeriodSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'gracePeriodDays' } },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'BillingPrePayment' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'minBalance' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'remainingBalance' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lastRefillDate' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'BillingMonthly' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'BillingSubscription' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stripeConfig' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'customerId' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'paymentMethod' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'PaymentMethodCard' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'expMonth' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'expYear' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'PaymentMethodACH' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'last4AccountNumber' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bank' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'PaymentMethodUnknown' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notificationSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'billingNotifications' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'emails' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateAmazonBusinessAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAmazonBusinessAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AmazonBusinessAccountInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAmazonBusinessAccount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'apiKey' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'adminToken' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'authProvider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'webhookURL' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'webhookURLVerified' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'marginAmount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'marginIsPercent' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'photoURL' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isApprovedForDirectCheckout' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'website' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'inventoryRequestLimits' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'uniqueStoreRequests' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'uniqueProductRequests' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'jwtValidationKey' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hmacSecretKey' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amazonBusinessAccount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buyerEmail' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'amazonAccountEmail' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'oauthStatus' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'billingPeriodSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'BillingPrePayment' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'minBalance' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gracePeriodDays' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'remainingBalance' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lastRefillDate' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'BillingMonthly' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gracePeriodDays' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stripeConfig' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'customerId' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'paymentMethod' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'PaymentMethodCard' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'expMonth' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'expYear' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'PaymentMethodACH' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'last4AccountNumber' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bank' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'PaymentMethodUnknown' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notificationSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'billingNotifications' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'emails' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAmazonBusinessAccountMutation,
  UpdateAmazonBusinessAccountMutationVariables
>;
export const UserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'user' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accessScopes' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'apiKey' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'apiKeySecondary' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'adminToken' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'authProvider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'webhookURL' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'webhookURLVerified' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'marginAmount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'marginIsPercent' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'photoURL' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isApprovedForDirectCheckout' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'website' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'inventoryRequestLimits' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'uniqueStoreRequests' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'uniqueProductRequests' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'jwtValidationKey' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hmacSecretKey' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'brand' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'supportEmail' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryColor' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amazonBusinessAccount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buyerEmail' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'amazonAccountEmail' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'oauthStatus' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'billingPeriodSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'gracePeriodDays' } },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'BillingPrePayment' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'minBalance' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'remainingBalance' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lastRefillDate' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'BillingMonthly' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'BillingSubscription' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stripeConfig' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'customerId' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'paymentMethod' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'PaymentMethodCard' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'expMonth' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'expYear' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'PaymentMethodACH' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'last4AccountNumber' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bank' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'PaymentMethodUnknown' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notificationSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'billingNotifications' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'emails' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserQuery, UserQueryVariables>;
export const ProductsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Products' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CursorPaginationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductsFilterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductsSortInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'products' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'images' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'ShopifyProduct' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'store' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'storeCommissions' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'storeLogo' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProductsQuery, ProductsQueryVariables>;
export const InventoryRequestsDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'inventoryRequestsData' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'inventoryRequests' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'requestType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'storeInventoryRequestsCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productInventoryRequestsCount' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InventoryRequestsDataQuery, InventoryRequestsDataQueryVariables>;
export const RegenerateApiKeyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'regenerateApiKey' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regenerateApiKey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'apiKey' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'apiKeySecondary' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RegenerateApiKeyMutation, RegenerateApiKeyMutationVariables>;
export const RevokeSecondaryApiKeyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'revokeSecondaryApiKey' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revokeSecondaryApiKey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'apiKey' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'apiKeySecondary' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RevokeSecondaryApiKeyMutation, RevokeSecondaryApiKeyMutationVariables>;
